import React, { useEffect, useState } from 'react';
import api, { unwrap } from '../utils/api';

export default function FontsList() {
  const [fonts, setFonts] = useState([]);

  async function load() {
    const r = await api.get('/files/GetAllFonts');
    setFonts(unwrap(r) || []);
  }
  useEffect(() => { load(); }, []);

  async function remove(_id) {
    if (!window.confirm('Delete this font?')) return;
    await api.post('/files/DeleteFont', { _id });
    load();
  }

  return (
    <>
      <h1>Fonts ({fonts.length})</h1>
      <div className="card">
        <table className="table">
          <thead><tr><th>Name</th><th>Weight</th><th>Path</th><th></th></tr></thead>
          <tbody>
            {fonts.map(f => (
              <tr key={f._id}>
                <td>{f.name}</td>
                <td>{f.weight}</td>
                <td style={{ fontSize: 12, color: '#666' }}>{f.path}</td>
                <td><button className="btn small danger" onClick={() => remove(f._id)}>Del</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </>
  );
}
